/**
 * Collection / search PLP scroll persistence (back-forward, reload)
 * + passive scroll checkpoints to sessionStorage.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'skipp_plp_scroll_v1';

  function hasProductGridSection() {
    return Boolean(document.getElementById('ProductGridContainer'));
  }

  if (!hasProductGridSection()) return;

  try {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  } catch (_e) {
    /* ignore */
  }

  function currentStoragePath() {
    return window.location.pathname + window.location.search;
  }

  function navigationEntryType() {
    var entries =
      typeof performance !== 'undefined' && performance.getEntriesByType
        ? performance.getEntriesByType('navigation')
        : [];
    var n = entries && entries[0];
    return n && n.type ? n.type : '';
  }

  function readStoredScroll() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (
        parsed &&
        typeof parsed.top === 'number' &&
        typeof parsed.path === 'string'
      ) {
        return parsed;
      }
      var legacy = parseInt(raw, 10);
      return Number.isFinite(legacy) ? { top: legacy, path: currentStoragePath() } : null;
    } catch (_e) {
      return null;
    }
  }

  function clampScroll(top) {
    var maxScroll = Math.max(
      0,
      (document.documentElement && document.documentElement.scrollHeight - window.innerHeight) ||
        0
    );
    return Math.max(0, Math.min(top, maxScroll));
  }

  function applyScroll(top, scheduleExtra) {
    var y = clampScroll(top);
    window.scrollTo(0, y);
    if (!scheduleExtra) return;
    requestAnimationFrame(function () {
      window.scrollTo(0, clampScroll(top));
      setTimeout(function () {
        window.scrollTo(0, clampScroll(top));
      }, 0);
    });
  }

  /** Save checkpoints while browsing the PLP. */
  function saveScrollCheckpoint() {
    try {
      var y = window.scrollY || (document.documentElement && document.documentElement.scrollTop) || 0;
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ top: Math.round(y), path: currentStoragePath() })
      );
    } catch (_e) {
      /* private mode overflow */
    }
  }

  var scrollScheduled = false;
  function onScroll() {
    if (scrollScheduled) return;
    scrollScheduled = true;
    requestAnimationFrame(function () {
      scrollScheduled = false;
      saveScrollCheckpoint();
    });
  }

  /** Same-tab PDP navigation (skip new tab / modified clicks). */
  function opensNewTab(e, anchor) {
    if (e.defaultPrevented) return true;
    if (typeof e.button === 'number' && e.button !== 0) return true;
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return true;
    if (anchor.getAttribute && anchor.getAttribute('target') === '_blank') return true;
    return false;
  }

  function isSameOriginProductUrl(href) {
    try {
      var u = new URL(href, window.location.href);
      if (u.origin !== window.location.origin) return false;
      return /^\/products\/[^/]+/.test(u.pathname);
    } catch (_e) {
      return false;
    }
  }

  function shouldPersistClick(anchor, e) {
    if (opensNewTab(e, anchor)) return false;
    var href = anchor.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('javascript')) return false;
    if (!isSameOriginProductUrl(href)) return false;

    var container = document.getElementById('ProductGridContainer');
    if (!container || !container.contains(anchor)) return false;

    var card = anchor.closest('.card-wrapper, li.grid__item, .product-card-wrapper');
    if (!card || !container.contains(card)) return false;

    return true;
  }

  document.addEventListener(
    'click',
    function (e) {
      var anchor =
        e.target && e.target.closest && e.target.closest('a[href]');
      if (!anchor) return;
      if (!shouldPersistClick(anchor, e)) return;
      saveScrollCheckpoint();
    },
    true
  );

  window.addEventListener('scroll', onScroll, { passive: true });

  function maybeRestore(reason) {
    var stored = readStoredScroll();
    if (!stored || stored.path !== currentStoragePath()) return;

    var navType = navigationEntryType();
    if (reason === 'bfcache') navType = 'back_forward';

    if (navType !== 'back_forward' && navType !== 'reload') return;

    applyScroll(stored.top, true);
  }

  window.addEventListener('load', function () {
    maybeRestore('load');
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      maybeRestore('bfcache');
      return;
    }
    maybeRestore('pageshow');
  });
})();
